<!DOCTYPE html>
<ion-content #pageTop class="edit-profile direct-form-wrapper">
  <!-- opt template html -->
  <ion-grid class="payment-header-wrapper">
    <div [innerHTML]="optTemplateHtml | safeHtml"></div>
  </ion-grid>

  <form class="edit-profile-page" [formGroup]="accountDetails" (ngSubmit)="onSubmit()">
    <div class="form-wrapper">
     
      <div class="profile-wrapper fields-wrapper">

        <div class="guarantee-box">
        <div class="icon"><img alt="Protected icon" src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/icons8-protect-24.png?alt=media&token=3479d6f1-ce4c-426b-a839-9f6ab938e5fa"></div>
        <div class="guarantee-content">
            <h3>Protected by the Direct Debit Guarantee.</h3>
            <p>
                Full and immediate refund if a payment is
                taken in error. Set up in under 60 seconds.
            </p>
        </div>
    </div>

    <hr class="hr-style" />
        <div class="input-title">Account holder name </div>
        <mat-form-field class="full-width field-status" [ngClass]="{
          'field-error': accountDetails.get('cardholder_name')?.invalid && (accountDetails.get('cardholder_name')?.touched || accountDetails.get('cardholder_name')?.dirty),
          'field-success': accountDetails.get('cardholder_name')?.valid && (accountDetails.get('cardholder_name')?.touched || accountDetails.get('cardholder_name')?.dirty)
        }" appearance="none">
          <mat-label>Card holder Name *</mat-label>
          <input formControlName="cardholder_name" type="text" matInput />
        </mat-form-field>
        <ng-container *ngIf="getFieldError('cardholder_name') as error">
          <div class="status-message error">{{ error }}</div>
        </ng-container>

        

        <div class="col-set">
 <div class="input-wraper">
            <div class="input-title">Sort code </div>
            <mat-form-field class="full-width half-width field-status" [ngClass]="{
              'field-error': accountDetails.get('sort_code')?.invalid && (accountDetails.get('sort_code')?.touched || accountDetails.get('sort_code')?.dirty),
              'field-success': accountDetails.get('sort_code')?.valid && (accountDetails.get('sort_code')?.touched || accountDetails.get('sort_code')?.dirty)
            }" appearance="none">
              <mat-label>Enter 6 Digit sort code *</mat-label>
              <input formControlName="sort_code" type="text" matInput maxlength="8" (input)="onSortCodeInput($event)" (keydown)="onSortCodeKeydown($event)" />
            </mat-form-field>
            <ng-container *ngIf="getFieldError('sort_code') as error">
              <div class="status-message error">{{ error }}</div>
            </ng-container>
          </div>
          <div class="input-wraper">
<div class="input-title">Account number </div>
            <mat-form-field class="full-width field-status" [ngClass]="{
          'field-error': accountDetails.get('account_number')?.invalid && (accountDetails.get('account_number')?.touched || accountDetails.get('account_number')?.dirty),
          'field-success': accountDetails.get('account_number')?.valid && (accountDetails.get('account_number')?.touched || accountDetails.get('account_number')?.dirty)
        }" appearance="none">
          <mat-label>Enter 8 digit Account number *</mat-label>
          <input formControlName="account_number" type="text" matInput />
        </mat-form-field>
        
        <ng-container *ngIf="getFieldError('account_number') as error">
          <div class="status-message error">{{ error }}</div>
        </ng-container>
          </div>
          
          
        </div>

          
          <!-- <div class="lookup-btn">
            <button type="button" (click)="lookupAddress()">Look-up Address</button>
          </div> -->
<div class="input-title">Address line 1 </div>
        <mat-form-field class="full-width field-status" [ngClass]="{
          'field-error': accountDetails.get('address_1')?.invalid && (accountDetails.get('address_1')?.touched || accountDetails.get('address_1')?.dirty),
          'field-success': accountDetails.get('address_1')?.valid && (accountDetails.get('address_1')?.touched || accountDetails.get('address_1')?.dirty)
        }" appearance="none">
          <mat-label>Address Line 1 *</mat-label>
          <input formControlName="address_1" type="text" matInput />
        </mat-form-field>
        <ng-container *ngIf="getFieldError('address_1') as error">
          <div class="status-message error">{{ error }}</div>
        </ng-container>
<div class="input-title">Address line 2 <span>Optional</span> </div>
        <mat-form-field class="full-width field-status" [ngClass]="{
          'field-error': accountDetails.get('address_2')?.invalid && (accountDetails.get('address_2')?.touched || accountDetails.get('address_2')?.dirty),
          'field-success': accountDetails.get('address_2')?.valid && (accountDetails.get('address_2')?.touched || accountDetails.get('address_2')?.dirty)
        }" appearance="none">
          <mat-label>Address Line 2</mat-label>
          <input formControlName="address_2" type="text" matInput />
        </mat-form-field>
        <ng-container *ngIf="getFieldError('address_2') as error">
          <div class="status-message error">{{ error }}</div>
        </ng-container>

        <div class="col-set">
          <div class="input-wraper">
            <div class="input-title">Town / City </div>
            <mat-form-field class="full-width field-status" [ngClass]="{
          'field-error': accountDetails.get('town')?.invalid && (accountDetails.get('town')?.touched || accountDetails.get('town')?.dirty),
          'field-success': accountDetails.get('town')?.valid && (accountDetails.get('town')?.touched || accountDetails.get('town')?.dirty)
        }" appearance="none">
          <mat-label>Enter Town / City *</mat-label>
          <input formControlName="town" type="text" matInput />
        </mat-form-field>
        <ng-container *ngIf="getFieldError('town') as error">
          <div class="status-message error">{{ error }}</div>
        </ng-container>
          </div>
          <div class="input-wraper">
<div class="input-title">Postcode </div>
            <mat-form-field class="full-width field-status" [ngClass]="{
              'field-error': accountDetails.get('post_code')?.invalid && (accountDetails.get('post_code')?.touched || accountDetails.get('post_code')?.dirty),
              'field-success': accountDetails.get('post_code')?.valid && (accountDetails.get('post_code')?.touched || accountDetails.get('post_code')?.dirty)
            }" appearance="none">
              <mat-label>Enter Postcode *</mat-label>
              <input formControlName="post_code" type="text" matInput />
            </mat-form-field>
            <ng-container *ngIf="getFieldError('post_code') as error">
              <div class="status-message error">{{ error }}</div>
            </ng-container>
          
          </div>
          </div>

        <hr class="hr-style" />

        <div class="direct-debit-box">
          <div class="logo">
            <img src="https://firebasestorage.googleapis.com/v0/b/hatchster-firebase-project.appspot.com/o/ddi-removebg-preview.png?alt=media&token=050217be-6b46-4a98-a8a0-04cb1c51f5e9" alt="Direct Debit">
          </div>
          <div class="text">
            Protected by the Direct Debit Guarantee.<br>
            You'll get advance notice of changes and can
            cancel anytime.
          </div>
        </div>

      </div>

      

      <div class="updated-btn">
        <ion-button expand="block" class="capsule-btn" [disabled]="accountDetails.invalid" type="submit" (click)="startSpinner()">
          <p> START MY 20 LINES FREE TRIAL - £0.00 </p>
          @if (spinnerAnimation) {
            <div class="spinners">
              <mat-progress-spinner mode="determinate" value="100" class="track-spinner" diameter="40">
              </mat-progress-spinner>
              <mat-progress-spinner class="spinner-circle" mode="determinate" [value]="progressBar" diameter="40">
              </mat-progress-spinner>
            </div>
          }
        </ion-button>
      </div>
      <a (click)="openNoThanks()" class="nothanks">No thanks</a> 
    </div>
  </form>
</ion-content>